import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { hasInvoicePermission } from "@/lib/receivedInvoices";
import { hasProcurement } from "@/lib/procurement";

export function InvoiceNavigation() {
  const { user } = useAuth(),
    navigate = useNavigate(),
    { pathname } = useLocation();
  const items = [
    { path: "/nabava/ulazni-racuni", label: "Popis računa", visible: hasInvoicePermission(user) },
    {
      path: "/nabava/ulazni-racuni/uprava",
      label: "Uprava",
      visible: hasInvoicePermission(user) && hasInvoicePermission(user, "odobri_placanje"),
    },
    { path: "/nabava/ulazni-racuni/bez-narudzbe", label: "Bez narudžbe", visible: hasInvoicePermission(user) || hasProcurement(user, "create") },
  ];
  return (
    <nav className="flex flex-wrap gap-2" aria-label="Ulazni računi">
      {items
        .filter((item) => item.visible)
        .map((item) => (
          <Button
            key={item.path}
            variant="secondary"
            aria-current={(pathname === item.path || (item.path.endsWith("/bez-narudzbe") && pathname.startsWith(`${item.path}/`))) ? "page" : undefined}
            onClick={() => navigate(item.path)}
          >
            {item.label}
          </Button>
        ))}
    </nav>
  );
}
